import { definicoesDeParametros, parametrosDoObjeto, type ObjetoTabletop } from '../../dominio/tabletop'

/**
 * As medidas da peça (ângulo e comprimento da escada, altura do toco, razão
 * do sistema…) na barra da peça selecionada: ao soltar uma peça na cena, as
 * opções dela já aparecem junto dela, sem abrir o editor. Um controle
 * deslizante por medida, com o valor escrito ao lado. Nada aparece para peças
 * sem medidas.
 */
export function MedidasRapidas({
  objeto,
  aoAtualizar,
  aoAlterarEdicaoContinua,
}: {
  objeto: ObjetoTabletop
  aoAtualizar: (id: string, parametros: Record<string, number>) => void
  aoAlterarEdicaoContinua?: (ativa: boolean) => void
}) {
  const definicoes = definicoesDeParametros(objeto.tipo)
  if (definicoes.length === 0) return null
  const valores = parametrosDoObjeto(objeto)
  const travada = objeto.bloqueado === true
  return (
    <fieldset className="tt-medidas-rapidas" disabled={travada}>
      <legend>Medidas de {objeto.nome}</legend>
      {definicoes.map((d) => {
        const valor = valores[d.chave]!
        const texto = d.opcoes
          ? (d.opcoes[Math.round(valor)] ?? String(valor))
          : d.unidade === ''
            ? valor >= 0.5 ? 'sim' : 'não'
            : `${Number(valor.toFixed(2)).toLocaleString('pt-BR')}${d.unidade === '°' ? '°' : ` ${d.unidade}`}`
        return (
          <label key={d.chave} className="tt-medidas-rapidas__medida">
            <span className="tt-medidas-rapidas__texto" title={`${d.rotulo}: ${texto}`}>
              <span className="tt-medidas-rapidas__rotulo">{d.rotulo}</span>
              <strong>{texto}</strong>
            </span>
            <input
              type="range"
              aria-label={d.rotulo}
              min={d.min}
              max={d.max}
              step={d.passo}
              value={valor}
              onPointerDown={() => aoAlterarEdicaoContinua?.(true)}
              onPointerUp={() => aoAlterarEdicaoContinua?.(false)}
              onPointerCancel={() => aoAlterarEdicaoContinua?.(false)}
              onChange={(e) => aoAtualizar(objeto.id, { [d.chave]: Number(e.target.value) })}
            />
          </label>
        )
      })}
    </fieldset>
  )
}
